import styled from "styled-components";
import {Typography} from "antd";

export const VTextContainer = styled(Typography.Text)`
    font-size: ${props =>
        typeof props.fontSize === "number"
            ? `${props.fontSize}px`
            : props.fontSize
            ? props.fontSize
            : "14px"};
    color: ${props => props.color};
`;
